import * as React from 'react';

import { AddToInsightSVG, OverviewSVG, ParticipantsSVG, PlanSVG, QuestionBankSVG, SingleUserSVG } from '../../../svgs';

export type TabType = 'overview' | 'plan' | 'audience' | 'test' | 'participants';

interface Props {
  current: TabType;
  onSelect?: (tab: TabType) => void;
  isPublished: boolean;
}

const TAB_ICONS = {
  overview: OverviewSVG,
  plan: PlanSVG,
  audience: SingleUserSVG,
  test: AddToInsightSVG,
  participants: ParticipantsSVG
};

const TAB_LABELS = {
  overview: 'Overview',
  plan: 'Plan',
  audience: 'Audience',
  test: 'Test',
  participants: 'Participants'
};

const BASE_TABS = ['overview', 'plan', 'audience', 'test'];

export const Tabs: React.FC<Props> = ({ current, onSelect, isPublished }) => {
  const handleClick = (tab: TabType) => {
    onSelect?.(tab);
  };

  const tabs = [...BASE_TABS, ...(isPublished ? ['participants'] : [])] as TabType[];

  return (
    <div className='w-48 space-y-2 p-3'>
      <nav className='flex flex-col space-y-1'>
        {tabs.map((tab) => {
          const Icon = TAB_ICONS[tab];
          const isActive = current === tab;

          return (
            <>
              <button
                key={tab}
                onClick={() => handleClick(tab)}
                className={`flex items-center space-x-2 rounded-md px-2 py-1.5 text-xs font-medium ${
                  isActive ? 'bg-indigo-50 text-indigo-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <Icon className='h-4 w-4' />
                <span>{TAB_LABELS[tab]}</span>
              </button>
              {tab === 'overview' && <hr className='my-2 border-gray-200' />}
            </>
          );
        })}
      </nav>
    </div>
  );
};
